import React from "react";
import { siteConfig } from "../config/site.config";
import { useLocation } from "react-router-dom";

interface LeftTextSectionProps {
  headerTitle?: string;
  headerDescription?: string;
  secondaryText?: string;
  imageUrl?: string;
}

const LeftTextSection: React.FC<LeftTextSectionProps> = ({
  headerTitle = "",
  headerDescription = "",
  secondaryText = "",
  imageUrl = "",
}) => {
  const location = useLocation();
  const pageContent =
    siteConfig.pagesContent[
      location.pathname as keyof typeof siteConfig.pagesContent
    ];
  headerTitle = pageContent.headerTitle;
  headerDescription = pageContent.headerDescription;
  secondaryText = pageContent.secondaryText;
  imageUrl = pageContent.imageUrl;

  return (
    <>
      <section className={"flex justify-center flex-col-reverse md:flex-row"}>
        <div className={"p-8 flex-1 gap-4 flex flex-col justify-center"}>
          <h1 className={"text-h2 text-primary mb-8 uppercase font-extralight"}>
            {headerTitle}
          </h1>
          {/* <p>{headerDescription}</p>
          <p className="pt-4">{secondaryText}</p> */}
          <p className="font-bold">
            March 21, 2019. The day before my daughter&rsquo;s birthday. She was
            turning 10.
          </p>
          <p>Like any mom, I wanted to do something special.</p>
          <p>
            At that time, we were living in a small town in the far north of
            Russia &mdash; you know, where it&rsquo;s freezing almost all year,
            the northern lights glow in the sky, and sometimes even bears wander
            out of the forest into the streets. Not exactly a place with endless
            options to impress a child!
          </p>
          <p>
            As someone who loves creating a little magic in the kitchen, I
            decided to bake a cake.
          </p>
          <div>
            <p>But the magic didn't happen...</p>
            <p>This happened instead...</p>
          </div>
          {/* <p>"Photo"</p> */}
          <p>That was a turning point.</p>
          <p>
            The kind of moment when you open the fridge and tears come to your
            eyes - not from pride or joy, but from the feeling that you could
            have done better... and didn&rsquo;t.
          </p>
          <div>
            <p>Then came courses.</p> <p>And more courses.</p>
            <p> Practice after practice at home.</p>
          </div>
          <p>
            Thankfully, I had friends who were more than happy to taste
            everything!
          </p>
          <p>Then came the first orders.</p>
          <p>And then&hellip; I got tired. Maybe even a little burned out.</p>
          <div>
            <p>Then life changed - I moved to the United States.</p>
            <p>
              And as many know, life in a new country doesn't always fall into
              place quickly or smoothly.
            </p>
          </div>
          <p>
            But love for beauty and a bit of magic doesn&rsquo;t just disappear.
          </p>
          <p>
            Over the years in the U.S., I kept baking &mdash; bringing my cakes
            to birthdays, celebrations, and gatherings for friends, colleagues,
            and people around me.
          </p>
          <div>
            <p>And maybe it was the feedback...</p>
            <p>The reactions...</p>
            <p>The way people felt when they tasted my desserts...</p>
          </div>
          <p>That became the final note.</p>
          <p>And I thought - why not try?</p>
          <p></p>
        </div>
        <div className={"bg-cover flex-1 p-0 md:p-8"}>
          <img
            src={imageUrl}
            alt="Section background"
            className="w-full h-full object-cover"
          />
        </div>
      </section>
    </>
  );
};

export default LeftTextSection;
